<template>
  <div id="home">
    <Jumbotron small-title="Dirección Distrital de Liquidaciones" v-bind:title="pageTitle" subtitle="Panel de Administración"/>
    <div class="page-content">
      <div class="container">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import Jumbotron from "@/components/core/Jumbotron.vue";
  export default {
    components: {
      Jumbotron,
    },
    computed: {
      pageTitle() {
        return this.$route.meta.title;
      },
    },
  };
</script>